import { combineReducers } from 'redux-immutable'
import { participants, participant } from './participants/reducer'
import { session, content, tour } from './simulation/reducer'

const reducer = combineReducers({
  participant,
  participants,
  session,
  content,
  tour
})

export default reducer
export { reducer }
